import {
	Button,
	Card,
	Input,
	InputGroup,
	Container
} from "reactstrap";
import {motion} from "framer-motion";
import RefStrap from "../../lib/Utils/RefStrap";

const MotionContainer = motion(RefStrap(Container));
const MotionCard = motion(RefStrap(Card));
const MotionButton = motion(RefStrap(Button));
const MotionInput = motion(RefStrap(Input));
const MotionInputGroup = motion(RefStrap(InputGroup));

export {MotionContainer, MotionCard, MotionButton, MotionInput, MotionInputGroup};
